import React from 'react';
import { Card } from './ui/Card';
import { Monitor, TrendingUp, Check } from 'lucide-react';
export function UniqueValue() {
  return <section className="py-20 bg-[#0A0E27] relative overflow-hidden" data-id="element-298">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#141B3A]/50 to-transparent -z-10" data-id="element-299"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-300">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-301">
          <div data-id="element-302">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-303">
              IT + Sales ={' '}
              <span className="text-[#FF5722]" data-id="element-304">Your Advantage</span>
            </h2>
            <p className="text-lg text-[#94A3B8] mb-8 leading-relaxed" data-id="element-305">
              Most CRM consultants are either pure technicians who don't
              understand sales, or salespeople without deep technical knowledge.
              I combine both.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-306">
              <div className="flex items-start gap-4" data-id="element-307">
                <div className="w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center flex-shrink-0" data-id="element-308">
                  <Monitor className="w-6 h-6 text-blue-500" data-id="element-309" />
                </div>
                <div data-id="element-310">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-311">
                    IT & Development
                  </h3>
                  <ul className="space-y-2 text-[#94A3B8]" data-id="element-312">
                    <li className="flex items-center gap-2" data-id="element-313">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-314" />
                      Programming (PHP, JS, Python)
                    </li>
                    <li className="flex items-center gap-2" data-id="element-315">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-316" />
                      Complex Web Applications
                    </li>
                    <li className="flex items-center gap-2" data-id="element-317">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-318" />
                      Professional IT Architecture
                    </li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-319">
                <div className="w-12 h-12 rounded-lg bg-[#FF5722]/10 flex items-center justify-center flex-shrink-0" data-id="element-320">
                  <TrendingUp className="w-6 h-6 text-[#FF5722]" data-id="element-321" />
                </div>
                <div data-id="element-322">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-323">
                    Sales & Practice
                  </h3>
                  <ul className="space-y-2 text-[#94A3B8]" data-id="element-324">
                    <li className="flex items-center gap-2" data-id="element-325">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-326" />3 Years Active
                      Sales Experience
                    </li>
                    <li className="flex items-center gap-2" data-id="element-327">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-328" />
                      B2B and B2C Expertise
                    </li>
                    <li className="flex items-center gap-2" data-id="element-329">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-330" />
                      Built Own Sales Team
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="relative" data-id="element-331">
            <Card className="p-8 border-[#334155] bg-[#141B3A]/80 backdrop-blur-sm" data-id="element-332">
              <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-333">
                The Result
              </h3>
              <div className="space-y-4" data-id="element-334">
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-335">
                  <span className="text-[#94A3B8]" data-id="element-336">Technically Robust</span>
                  <span className="text-green-500 font-bold" data-id="element-337">100%</span>
                </div>
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-338">
                  <span className="text-[#94A3B8]" data-id="element-339">Practically Usable</span>
                  <span className="text-green-500 font-bold" data-id="element-340">100%</span>
                </div>
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-341">
                  <span className="text-[#94A3B8]" data-id="element-342">Team Adoption</span>
                  <span className="text-green-500 font-bold" data-id="element-343">High</span>
                </div>
              </div>
              <div className="mt-8 text-center" data-id="element-344">
                <p className="text-white font-medium mb-2" data-id="element-345">
                  "No theory – only practice."
                </p>
                <p className="text-sm text-[#94A3B8]" data-id="element-346">
                  Every feature was tested and optimized in real-world use.
                </p>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}